var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"popover-info",staticStyle:{"border":"none"},attrs:{"tabindex":"0","id":_vm.popid,"data-toggle":"popover"}},[_c('InfoIcon'),_c('b-popover',{attrs:{"target":_vm.popid,"triggers":"focus"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }